import Vue from 'vue'
import './plugins/axios'
import App from './App.vue'
import router from './router'
import store from './store'
import AWS from "aws-sdk";



import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'

import VueCookies from "vue-cookies";

Vue.use(VueCookies);
// Install BootstrapVue
Vue.use(BootstrapVue)
// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin)

import VueHotkey from 'v-hotkey'
Vue.use(VueHotkey)


import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import anime from 'animejs/lib/anime.es.js'

// const __svg__ = { path: './assets/images/icons/*.svg', name: 'assets/images/[hash].sprite.svg' }
// svgSpriteLoader(__svg__.filename)
Vue.prototype.$anime = anime;

Vue.config.productionTip = false
Vue.$cookies.config("7d");

AWS.config.update({
  region: "ap-northeast-2",
  credentials: new AWS.CognitoIdentityCredentials({
    IdentityPoolId: "ap-northeast-2:dc9b0c57-3ee5-47da-9239-931dcf6da667",
  }),
});

var s3 = new AWS.S3({
  apiVersion: "2006-03-01",
  params: { Bucket: "com.cedu.csd" },
});

Vue.prototype.$S3 = s3;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
